import React, {useState, useEffect, useMemo, useCallback} from 'react'
import {useIntl} from 'react-intl'
import {KTCard, KTCardBody, Table, Loading} from '../../../components'
import {CustomCell} from '../../../components/Table/columns/CustomCell'
import {CustomHeader} from '../../../components/Table/columns/CustomHeader'
import {ListHeader} from '../../../components/Table/header/ListHeader'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'

import {useDispatch, useSelector} from 'react-redux'
import {constructionsiteGetAll, constructionsiteExcel} from '../../../redux/slices/project.slice'

import {pagination} from '../../../helpers'

import {useMemoizedStaticData} from '../../../utils/performanceOptimizations'

const selectConstructionSiteData = (state) => ({
  constructionsite: state.project.constructionsite,
  loading: state.project.loading,
})

function List() {
  const intl = useIntl()
  const {constructionsite, loading} = useSelector(selectConstructionSiteData)
  const dispatch = useDispatch()
  const pageKey = 'CONSTRUCTIONSITE'

  const [params, setParams] = useState(pagination)

  useEffect(() => {
    dispatch(constructionsiteGetAll(params))
  }, [dispatch, params])

  const handleSorting = useCallback((item) => {
    setParams((prevState) => ({...prevState, sort: item && item.sort, order: item && item.order}))
  }, [])

  const handleSearch = useCallback((item) => {
    setParams((prevState) => ({...prevState, name: item}))
  }, [])

  const handlePagination = useCallback((pagination) => {
    setParams((prevState) => ({...prevState, ...pagination}))
  }, [])

  const handleExcelExport = useCallback(() => {
    dispatch(
      constructionsiteExcel({
        params,
        fileName: intl.formatMessage({id: 'BC.CONSTRUCTIONSITE'}),
      })
    )
  }, [dispatch, params, intl])

  const columns = useMemo(
    () => [
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'CONSTRUCTIONSITE.SEARCH.PROJECTNAME'})}
            className='min-w-125px'
          />
        ),
        accessor: 'projectName',
        Cell: ({...props}) => <CustomCell item={props} />,
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'CONSTRUCTIONSITE.SEARCH.NAME'})}
            className='min-w-125px'
          />
        ),
        accessor: 'name',
        Cell: ({...props}) => <CustomCell item={props} />,
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'CONSTRUCTIONSITE.SEARCH.DISTRICTNAME'})}
            className='min-w-125px'
          />
        ),
        accessor: 'districtName',
        Cell: ({...props}) => <CustomCell item={props} />,
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'CONSTRUCTIONSITE.SEARCH.PROVINCENAME'})}
            className='min-w-125px'
          />
        ),
        accessor: 'provinceName',
        Cell: ({...props}) => <CustomCell item={props} />,
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'CONSTRUCTIONSITE.SEARCH.TOTALWORK'})}
            className='min-w-125px'
          />
        ),
        accessor: 'totalWork',
        Cell: ({...props}) => <CustomCell item={props} />,
      },
    ],
    [intl, handleSorting]
  )

  const actionButtons = useMemoizedStaticData(
    () => [
      {
        title: 'BUTTON.EXCEL',
        onClick: handleExcelExport,
        icon: '/images/icons/duotune/arrows/arr044.svg',
        variant: 'light-primary',
      },
    ],
    [handleExcelExport]
  )

  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'BC.CONSTRUCTIONSITE'})}</PageTitle>
      <KTCard>
        <ListHeader search={handleSearch} actionButtons={actionButtons} pages={pageKey} />
        <KTCardBody>
          {!constructionsite && <ListLoading />}
          {constructionsite && (
            <Table
              items={constructionsite}
              cols={columns}
              handlePagination={handlePagination}
              paddless
              pages={pageKey}
            />
          )}
        </KTCardBody>
      </KTCard>

      {loading && <Loading />}
    </>
  )
}
export {List}
